import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-b5c0d91e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "config-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "config-content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "content-header" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "header-info" }, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Configuración del Sistema"),
        /*#__PURE__*/ _createElementVNode("p", { class: "subtitle" }, "Asigna los almacenes a los distintos flujos del sistema")
    ])
], -1 /* HOISTED */));
const _hoisted_5 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Cargando configuración...", -1 /* HOISTED */));
const _hoisted_7 = {
    key: 1,
    class: "config-grid animate__animated animate__fadeInUp"
};
const _hoisted_8 = { class: "card-icon" };
const _hoisted_9 = { class: "card-details" };
const _hoisted_10 = { class: "flujo-name" };
const _hoisted_11 = {
    key: 0,
    class: "card-action"
};
const _hoisted_12 = { class: "form-group premium-select" };
const _hoisted_13 = { class: "label-with-lock" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Almacén Asignado", -1 /* HOISTED */));
const _hoisted_15 = ["onClick", "title"];
const _hoisted_16 = ["value", "onChange", "disabled"];
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "-- Seleccionar Almacén --", -1 /* HOISTED */));
const _hoisted_18 = ["value"];
const _hoisted_19 = {
    key: 1,
    class: "card-action readonly-action"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Almacén Asignado", -1 /* HOISTED */));
const _hoisted_21 = { class: "readonly-value" };
import { ref, onMounted } from 'vue';
import Header from '@/components/HeaderDashboard.vue';
import Sidebar from '@/components/Sidebar.vue';
import { ConfiguracionAlmacenService } from '@/services/ConfiguracionAlmacenService';
import { AlmacenService } from '@/services/AlmacenService';
import { SettingsIcon, Loader2Icon, LockIcon, UnlockIcon } from 'lucide-vue-next';
import Swal from 'sweetalert2';
import { hasPermission } from '@/store/userStore';
import { PERMISSIONS } from '@/constants/permissions';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const P = PERMISSIONS;
        const can = hasPermission;
        const configuraciones = ref([]);
        const almacenes = ref([]);
        const loading = ref(true);
        const updatingId = ref(null);
        const unlockedIds = ref(new Set());
        const toggleLock = (id) => {
            const newSet = new Set(unlockedIds.value);
            if (newSet.has(id)) {
                newSet.delete(id);
            }
            else {
                newSet.add(id);
            }
            unlockedIds.value = newSet;
        };
        const isUnlocked = (id) => unlockedIds.value.has(id);
        const loadData = async () => {
            loading.value = true;
            try {
                const [configRes, almacenesRes] = await Promise.all([
                    ConfiguracionAlmacenService.getAll(),
                    AlmacenService.getAllAlmacenesSimple()
                ]);
                configuraciones.value = configRes || [];
                almacenes.value = almacenesRes || [];
            }
            catch (error) {
                Swal.fire('Error', error.message || 'No se pudo cargar la configuración', 'error');
            }
            finally {
                loading.value = false;
            }
        };
        const getAlmacenName = (id) => {
            if (!id)
                return 'No asignado';
            const match = almacenes.value.find(a => a.almacenId === id);
            return match ? match.nombreAlmacen : 'Desconocido';
        };
        const formatFlujoName = (flujo) => {
            if (!flujo)
                return '';
            return flujo
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        };
        const confirmUpdate = async (conf, event) => {
            const select = event.target;
            const newAlmacenIdStr = select.value;
            const newAlmacenId = newAlmacenIdStr ? parseInt(newAlmacenIdStr) : null;
            if (newAlmacenId === conf.almacenId)
                return;
            const newAlmacenName = getAlmacenName(newAlmacenId);
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: `Vas a cambiar el almacén del flujo "${formatFlujoName(conf.flujo)}" a "${newAlmacenName}". Esto afectará dónde se reflejan estas operaciones en el sistema.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
                confirmButtonText: 'Sí, cambiar almacén',
                cancelButtonText: 'Cancelar'
            });
            if (result.isConfirmed) {
                updatingId.value = conf.id;
                try {
                    await ConfiguracionAlmacenService.update(conf.id, {
                        almacenId: newAlmacenId
                    });
                    conf.almacenId = newAlmacenId;
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    });
                    Toast.fire({
                        icon: 'success',
                        title: `Almacén actualizado correctamente`
                    });
                    // Relock after success
                    const newSet = new Set(unlockedIds.value);
                    newSet.delete(conf.id);
                    unlockedIds.value = newSet;
                }
                catch (error) {
                    Swal.fire('Error', error.message || 'Error al actualizar', 'error');
                    select.value = conf.almacenId ? conf.almacenId.toString() : '';
                }
                finally {
                    updatingId.value = null;
                }
            }
            else {
                select.value = conf.almacenId ? conf.almacenId.toString() : '';
            }
        };
        onMounted(() => {
            loadData();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("main", _hoisted_3, [
                        _hoisted_4,
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_unref(Loader2Icon), {
                                    size: 48,
                                    class: "spinner"
                                }),
                                _hoisted_6
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configuraciones.value, (conf) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: conf.id,
                                        class: "config-card"
                                    }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_unref(SettingsIcon), {
                                                size: 32,
                                                color: "#3b82f6"
                                            })
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("h3", null, [
                                                _createTextVNode("Flujo: "),
                                                _createElementVNode("span", _hoisted_10, _toDisplayString(formatFlujoName(conf.flujo)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("p", null, _toDisplayString(conf.descripcion || 'Configuración para este flujo en el sistema'), 1 /* TEXT */)
                                        ]),
                                        (_unref(can)(_unref(P).CONFIGURACION.SISTEMA_MANAGE))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _hoisted_14,
                                                        _createElementVNode("button", {
                                                            class: "lock-btn",
                                                            onClick: ($event) => (toggleLock(conf.id)),
                                                            title: isUnlocked(conf.id) ? 'Bloquear' : 'Desbloquear para editar'
                                                        }, [
                                                            (isUnlocked(conf.id))
                                                                ? (_openBlock(), _createBlock(_unref(UnlockIcon), {
                                                                    key: 0,
                                                                    size: 16,
                                                                    color: "#3b82f6"
                                                                }))
                                                                : (_openBlock(), _createBlock(_unref(LockIcon), {
                                                                    key: 1,
                                                                    size: 16,
                                                                    color: "#94a3b8"
                                                                }))
                                                        ], 8 /* PROPS */, _hoisted_15)
                                                    ]),
                                                    _createElementVNode("select", {
                                                        value: conf.almacenId,
                                                        class: "form-control select-premium",
                                                        onChange: ($event) => (confirmUpdate(conf, $event)),
                                                        disabled: updatingId.value === conf.id || !isUnlocked(conf.id)
                                                    }, [
                                                        _hoisted_17,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(almacenes.value, (almacen) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: almacen.almacenId,
                                                                value: almacen.almacenId
                                                            }, _toDisplayString(almacen.nombreAlmacen), 9 /* TEXT, PROPS */, _hoisted_18));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_16)
                                                ])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _hoisted_20,
                                                _createElementVNode("div", _hoisted_21, _toDisplayString(getAlmacenName(conf.almacenId)), 1 /* TEXT */)
                                            ]))
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                    ])
                ])
            ]));
        };
    }
});
